var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareNetworkFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 25a4.5 4.5 0 11-8.732-1.531l-6.625-4.257a4.5 4.5 0 110-6.425l6.625-4.25a4.51 4.51 0 111.084 1.682l-6.625 4.256a4.5 4.5 0 010 3.062l6.625 4.257A4.5 4.5 0 0126.5 25z"
  })));
}
export default SvgShareNetworkFill;